import { render, staticRenderFns } from "./WaferBoxLabelDialog.vue?vue&type=template&id=459fb102&scoped=true"
import script from "./WaferBoxLabelDialog.vue?vue&type=script&lang=js"
export * from "./WaferBoxLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./WaferBoxLabelDialog.vue?vue&type=style&index=0&id=459fb102&prod&scoped=true&lang=css"
import style1 from "./WaferBoxLabelDialog.vue?vue&type=style&index=1&id=459fb102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459fb102",
  null
  
)

export default component.exports